import axiosInstance from './axiosInstance';
import { variables } from './variables';

const API_URL = variables.CATEGORY_API;

// Fetch all categories
export const fetchCategories = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};
